export const iconFontAwesomeMediaplaybackPause = (
	<i className="fa-solid fa-pause"></i>
);
